<template>
  <el-container>
    <el-main style="padding: 0; width: 100vh">
      <view-table
          ref="viewTable"
          :filter="filter"
          :limits="limits"
          :columns-property="columnsProperty"
          module="basic"
          url="workshops"
          @delete="deleteHandle"
          @addOrEdit="addEditHandle"
          @select="selectHandle"
          @reset="resetHandle">
        <template slot="otherBtn">
          <el-button v-if="delAllAuth" :disabled="!selection.length" type="danger" @click="deleteRows"> 批量删除 </el-button>
        </template>
        <template slot="adSearch">
          <el-form :inline="true" :model="filter" @submit.native.prevent @keyup.enter.native="loadData(1)">
            <el-form-item label="车间编号">
              <el-input v-model.trim="filter.workshopNo" placeholder="请输入车间编号" clearable/>
            </el-form-item>
            <el-form-item label="车间名称">
              <el-input v-model.trim="filter.workshopName" placeholder="请输入车间名称" clearable/>
            </el-form-item>
            <el-form-item label="所属工厂">
              <el-input v-model.trim="filter.factoryName" placeholder="请输入所属工厂名称" clearable/>
            </el-form-item>
          </el-form>
        </template>
      </view-table>
      <work-shop-edit ref="editPage" @save-success="loadData(1)"/>
    </el-main>
  </el-container>
</template>

<script>
  import ViewTable from "@/components/ViewTable.vue";
  import WorkShopEdit from "@/views/information/WorkShop/WorkShopEdit";

  export default {
    name: "WorkShopList",
    components: { WorkShopEdit, ViewTable },
    data() {
      return {
        limits:{
          addAuth:this.$auth(169),
          editAuth:this.$auth(171),
          delAuth:this.$auth(172),
        },
        delAllAuth:this.$auth(170),
        selection: [],
        filter: {
          workshopNo:"",
          workshopName:"",
          factoryName:"",
        },
        columnsProperty:[
          {
            key:"workshopNo",
            align:"center",
            width:120,
          },
          {
            key:"workshopName",
            align:"left",
            tooltip:true,
          },
          {
            key:"factoryName",
            align:"left",
            tooltip:true,
          },
          {
            key:"creatorName",
            align:"center",
            width:120,
          },
          {
            key:"createTime",
            align:"center",
            width:160,
          },
          {
            key: "action",
            align: "center",
            width: 140,
            slot: "action",
            fixed: "right",
          },
        ],
      };
    },
    methods: {
      // 查询
      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },

      // 新增、编辑
      addEditHandle(row) {
        this.$refs.editPage.open(row);
      },

      selectHandle(selection) {
        this.selection = selection;
      },

      // 单个删除
      deleteHandle(row) {
        this.$confirm("确定删除吗?", "提示", { type: "warning" }).then(() => {
          this.$http.delete("basic", "workshops", row.pkid).then((resp) => {
            if (resp.success) {
              this.loadData(1);
              this.$message.success("删除成功");
              this.selection = [];
            }
          });
        });
      },

      // 批量删除
      deleteRows() {
        let ids = [];
        this.selection.forEach((item) => {
          ids.push(item.pkid);
        });
        this.$confirm("确定删除吗?", "提示", { type: "warning" }).then(() => {
          this.$http.post("basic", "workshops/deleteBatch", ids).then((resp) => {
            if (resp.success) {
              this.loadData(1);
              this.$message.success("删除成功");
              this.selection = [];
            }
          });
        });
      },

      // 重置
      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
      },
    },
  };
</script>
